import { useEffect, useState } from 'react';
import { createOrder, getOrderByIdUser } from '../services/orderService'

export const useOrder = () => {
    const [order, setOrder] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const postOrder = async (data) => {
        setLoading(true);
        try {
            const response = await createOrder(data);
            setOrder([...order, response.data]);
            return response.data
        } catch (err) {
            setError('Failed to post Order');
        } finally {
            setLoading(false);
        }
    };

    const fetchOrders = async () => {
        try {
            setLoading(true);
            const response = await getOrderByIdUser();
            setOrder(response.data);

            setLoading(false);
        } catch (err) {
            setError('Failed to fetch products');
            setLoading(false);
        } finally {
            setLoading(false);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchOrders()
    }, []);

    return {
        order,
        loading,
        error,
        alert,
        postOrder,
        fetchOrders
    };
}